import { LMS_STAFF_ONLY } from './staff-only'

// Whether this person sees the LMS admin at all (staff-only.js): while the
// switch is closed, system administrators and root only. Lifted, everyone
// does, and the LMS role gates each entry as before.
export const lmsAdminVisible = state => !LMS_STAFF_ONLY || !!(state && (state.isSysAdmin || state.isSysRoot))

// Whether the connection drawer's API keys panel exists (Phase D D7): only
// once the switch is lifted. While it is closed the LMS registers no route
// that creates a key bound to a connection (404, not 403), and refuses every
// API key (401), so the panel is absent for everyone, system administrators
// and root included. (The LMS's own API key pages and their six routes are
// retired.) Read at call time, not import.
export const lmsApiKeysVisible = () => !LMS_STAFF_ONLY

// Whether the session's claims have arrived. The auth context starts with
// none until the first refresh, so before then nobody is a system
// administrator yet and a gate must wait rather than say "not found".
export const claimsKnown = state => !!(state && state.jwtClaims && Object.keys(state.jwtClaims).length > 0)
